module.exports = __webpack_public_path__ + "img/local_printshop.24c998ac.svg";